import { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { useLocation } from 'react-router-dom'

export default function AuthGate({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading, loginWithRedirect, error } = useAuth0()
  const location = useLocation()

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      // remember where the user tried to go
      loginWithRedirect({ appState: { returnTo: location.pathname + location.search } })
    }
  }, [isLoading, isAuthenticated, loginWithRedirect, location])



  if (error) return <p>Auth error: {error.message}</p>
  if (isLoading || !isAuthenticated) return <p>Checking session…</p>  // tiny loading screen
  return <>{children}</>
}